import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet, fnSave, fnGetTableById } from "@shared/api/restApi";
import { getInitPopUpData, getTablebySql } from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import usePanelSizes from "@shared/hooks/usePanelSizes";
import SnSearchBtn from "@shared/components/SnSearchBtn";
import SnTab from "@shared/components/SnTab";
interface popupProps {
  selectedData?: any;
  modalRef?: any;
}
interface RowData {
  KeyField?: string;

  [key: string]: any;
}

const filterNonZeroStockRows = (rows: RowData[]) =>
  rows.filter((row) => Number(row?.stock_qt) !== 0);

const SN_MTL_INV_REG_001_TEX_POP_01 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
      grid2: React.createRef(),
      grid3: React.createRef(),
      grid4: React.createRef(),
      grid5: React.createRef(),
    });
    const selectedTabPage = useRef<string>("1");
    const [columns, setColums] = useState<any>({
      grid1: [],
      grid2: [],
      grid3: [],
      grid4: [],
      grid5: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
      grid2: [],
      grid3: [],
      grid4: [],
      grid5: [],
    });

    const [gridFocus, setGridFocus] = useState(false);

    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const searchRef = useRef<any>(null);
    //#endregion
    //#region grid 길이 관련
    const cd_menu = modalRef?.cd_menu || "SN_MTL_INV_REG_001_TEX_POP_01";
    const defaultSize = { panel1width: "49.5%", panel2width: "49.5%" };
    const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize);
    useImperativeHandle(ref, () => ({
      getSelectedRow: () => [
        gridRefs.current["grid1"].current?.getSelectedRows() || [],
        filterNonZeroStockRows(
          gridRefs.current["grid2"].current?.getCheckedRows() || []
        ),
        filterNonZeroStockRows(
          gridRefs.current["grid3"].current?.getCheckedRows() || []
        ),
        filterNonZeroStockRows(
          gridRefs.current["grid4"].current?.getCheckedRows() || []
        ),
        filterNonZeroStockRows(
          gridRefs.current["grid5"].current?.getCheckedRows() || []
        ),
      ],
    }));
    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_MTL_INV_REG_001_TEX_POP_01",
            {}
          );
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormData(mergedData); // 조회조건 초기값
          setFormControlData(rtn.formControlData); // 조회조건 항목 설정
          setColums({
            grid1: rtn.grid.grid1,
            grid2: rtn.grid.grid2,
            grid3: rtn.grid.grid3,
            grid4: rtn.grid.grid4,
            grid5: rtn.grid.grid5,
          });
          await new Promise((resolve) => setTimeout(resolve, 0));
          //await onSearch();
        } catch (error: any) {}
      };
      fetchform();
    }, []);

    useEffect(() => {
      gridRefs.current["grid1"].current.selectAndFocusRow(0);
      setGridFocus(false);
    }, [gridFocus]);

    //#region Button Event
    const onSearch = () => {
      const fetchdatasource = async () => {
        try {
          const params = {
            id: "sn_mtl_inv_reg_001_tex_pop_01",
            params: searchRef.current.getFormdata(),
          };
          gridRefs.current["grid1"].current.resetUpdate();
          gridRefs.current["grid2"].current.resetUpdate();
          gridRefs.current["grid3"].current.resetUpdate();
          gridRefs.current["grid4"].current.resetUpdate();
          gridRefs.current["grid5"].current.resetUpdate();
          const data: any = await fnGetDataSet(params);
          setDataSources({
            grid1: data[0],
            grid2: data[1] || [],
            grid3: [],
            grid4: data[2],
            grid5: data[3],
          });
        } catch (error: any) {
          showDialog("error", error.message);
        }
      };
      fetchdatasource();
    };
    //#endregion

    //#region InitnewRowH
    const onTabChanged = async (tabIndex: any) => {
      selectedTabPage.current = tabIndex;
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      if (!focusedNodeH) {
        await showDialog("alter", "상단 행을 선택해 주세요");
        return;
      }
    };

    const onFocusedRowChanged = async (event: any) => {
      const selectedRow = event;
      if (selectedRow) {
        const no_so = selectedRow.no_so;
        gridRefs.current["grid2"].current.applyFilters({ no_so: no_so });
        gridRefs.current["grid2"].current.selectAndFocusRow(0);
        gridRefs.current["grid4"].current.applyFilters({ no_so: no_so });
        gridRefs.current["grid4"].current.selectAndFocusRow(0);
        gridRefs.current["grid5"].current.applyFilters({ no_so: no_so });
        gridRefs.current["grid5"].current.selectAndFocusRow(0);
        const searchData = searchRef.current.getFormdata();

        const mtl_inv_reg_001_tex_pop = {
          id: "mtl_inv_reg_001_tex_pop",
          params: {
            cd_firm: userInfo.cd_firm,
            no_po: selectedRow.no_po,
            no_so: selectedRow.no_so,
            cd_wh: selectedData.cd_wh,
            cd_biz: searchData.cd_biz,
            dt_from: searchData.dt_from,
            dt_to: searchData.dt_to,
            fg_search: searchData.fg_search,
            str_search: searchData.str_search,
            cd_cust: searchData.cd_cust,
          },
        };
        const data: any = await fnGetDataSet(mtl_inv_reg_001_tex_pop);

        setDataSources((prev: any) => ({ ...prev, grid3: data[0] }));
      } else {
        return;
      }
    };

    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: {
            onFocusedRowChanged: onFocusedRowChanged,
          },
        },
        grid2: {
          columns: columns.grid2,
          dataSource: dataSources.grid2,
          events: {
            //   onSelectionChanged: onSelectionChanged,
          },
        },
        grid3: {
          columns: columns.grid3,
          dataSource: dataSources.grid3,
        },
        grid4: {
          columns: columns.grid4,
          dataSource: dataSources.grid4,
        },
        grid5: {
          columns: columns.grid5,
          dataSource: dataSources.grid5,
        },
      }),
      [columns, dataSources]
    );

    return (
      <div className="h-full flex flex-col">
        <div className="mb-1">
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
          />
        </div>
        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>
        <div>
          <div style={{ height: "29vh", marginTop: "10px" }}>
            <SnGrid
              ref={gridRefs.current["grid1"]}
              columnConfig={grids.grid1.columns}
              rowData={grids.grid1.dataSource}
              etcProps={{
                rowSelection: "single",
              }}
              events={grids.grid1.events}
            />
          </div>
          <div style={{ height: "29vh", marginTop: "10px" }}>
            <SnTab
              titles={["주문PO", "기타PO", "원단", "상품"]}
              width={"100%"}
              onTabChanged={onTabChanged}
              body={[
                <div className="h-full">
                  <SnGrid
                    ref={gridRefs.current["grid2"]}
                    columnConfig={grids.grid2.columns}
                    rowData={grids.grid2.dataSource}
                    etcProps={{
                      rowSelection: "multiple",
                      ischeckboxSelection: true,
                      enableInitialSort: false,
                    }}
                    events={grids.grid2.events}
                  />
                </div>,
                <div className="h-full">
                  <SnGrid
                    ref={gridRefs.current["grid3"]}
                    columnConfig={grids.grid3.columns}
                    rowData={grids.grid3.dataSource}
                    etcProps={{
                      rowSelection: "multiple",
                      ischeckboxSelection: true,
                      enableInitialSort: false,
                    }}
                  />
                </div>,
                <div className="h-full">
                  <SnGrid
                    ref={gridRefs.current["grid4"]}
                    columnConfig={grids.grid4.columns}
                    rowData={grids.grid4.dataSource}
                    etcProps={{
                      rowSelection: "multiple",
                      ischeckboxSelection: true,
                      enableInitialSort: false,
                    }}
                  />
                </div>,
                <div className="h-full">
                  <SnGrid
                    ref={gridRefs.current["grid5"]}
                    columnConfig={grids.grid5.columns}
                    rowData={grids.grid5.dataSource}
                    etcProps={{
                      rowSelection: "multiple",
                      ischeckboxSelection: true,
                      enableInitialSort: false,
                    }}
                  />
                </div>,
              ]}
            />
          </div>
        </div>
      </div>
    );
  }
);

export default SN_MTL_INV_REG_001_TEX_POP_01;
